export default function ClosedDoorIcon({ className="", onClick=null }) {
  return (
    <>
      <svg className={className} onClick={onClick} viewBox="0 0 113 171" xmlns="http://www.w3.org/2000/svg">
        <path d="m0 0.97086v169.06c0 0.539 0.43288 0.971 0.96012 0.971h110.5c0.532 0 0.96-0.438 0.96-0.971v-169.06c0-0.53874-0.433-0.97086-0.96-0.97086h-110.5c-0.52723 0-0.96012 0.43773-0.96012 0.97086zm11.338 168.09v-157.4h88.897v157.4h-88.897zm99.158 0h-8.341v-158.37c0-0.5387-0.433-0.97081-0.96-0.97081h-90.817c-0.53276 0-0.9601 0.43771-0.9601 0.97081v158.37h-7.4978v-167.12h108.58v167.12z"/>
        <path d="m85.5 95c2.6234 0 4.75-1.7722 4.75-3.9583s-2.1266-3.9583-4.75-3.9583-4.75 1.7722-4.75 3.9583 2.1266 3.9583 4.75 3.9583z"/>
      </svg>
    </>
  );
}